import { useScriptCrisp, useScript, defineNuxtPlugin } from '#imports'

export default defineNuxtPlugin({
  name: "scripts:init",
  env: { islands: false },
  parallel: true,
  setup() {
    const crisp = useScriptCrisp({})
    return { provide: { $scripts: { crisp } } }
  }
})